import { render } from "./VerifyEmailBanner.vue?vue&type=template&id=1373e200&scoped=true"
import script from "./VerifyEmailBanner.vue?vue&type=script&lang=js"
export * from "./VerifyEmailBanner.vue?vue&type=script&lang=js"

import "./VerifyEmailBanner.vue?vue&type=style&index=0&id=1373e200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1373e200"]])

export default __exports__